import { EventBus } from "@/event-bus.js";
import HighRiskProducts from "@/utils/highRiskProducts.json";
import _ from "lodash";
class Helper {
    hideSection(state, sectionSeven, secFourCountries) {
        // // console.log("hideSection", section)

        let multi = false;
        let sections = state.form1.formSection;
        let selectedSubDivision = null;
        let selectedProducts = [];
        let filterSelectedCountries = [];


        let sectionSix = sections.find(
            (sec) =>
                sec.sectionTitle[state.selectedLanguage] == "Details of Services/Goods"
        );
        let foundCombo = sectionSix.formElements.find(
            (a) => a.inputType == "comboSelectProgressive");

        let eleNewCombo = state.userFormSubmitArray.find(
            (ele) => ele.elementId == foundCombo.id
        );

        if (eleNewCombo && eleNewCombo.elements.length) {
            // HideSection.hideSection(this.$store.state,sectionSeven, false);
            eleNewCombo.elements.map((el) => {
                // console.log("el", el);
                if (el.postValue && el.postValue.comboSelectTwo) {
                    selectedSubDivision = el.postValue.comboSelectTwo;
                    multi = el.isMultipleSelectSecond;
                }
            });
        }

        // console.log("selectedSubDivision", selectedSubDivision)
        // console.log("secFourCountries", secFourCountries)


        // filtering countries
        if (selectedSubDivision) {
            selectedSubDivision.map((subDivision) => {
                let foundDivision = multi && HighRiskProducts.industries ? HighRiskProducts.industries.find((division) => division.divisionName == subDivision.divisionName) : null;
                if (foundDivision) {
                    let foundSubDivision = multi && foundDivision.subDivisions ? foundDivision.subDivisions.find((subDivisionObject) => subDivisionObject.subDivisionName == subDivision.subDivisionName) : null;
                    if (foundSubDivision) {
                        secFourCountries.map((selectedCountry) => {
                            let foundSubDivisionCountry = multi && foundSubDivision.counties ? foundSubDivision.counties.find((subDivisionCountries) => subDivisionCountries.country == selectedCountry) : null;
                            if (foundSubDivisionCountry) {
                                let findIndexCountry = filterSelectedCountries.indexOf(foundSubDivisionCountry.country);
                                if (findIndexCountry == -1) {
                                    filterSelectedCountries.push(foundSubDivisionCountry.country);
                                }
                                foundSubDivisionCountry.products.map((product) => {
                                    selectedProducts.push(product);
                                });
                            }
                        });
                    }
                }
            });
        }

        // console.log("selectedProducts", selectedProducts)

        /*
        HighRiskProducts.industries.map((ind) => {
            if (ind && ind.subDivisions && ind.subDivisions.length) {
                ind.subDivisions.map((sd) => {
                    let foundSubDivision = multi && selectedSubDivision ? selectedSubDivision.find((d) => d.subDivisionName == sd.subDivisionName) : selectedSubDivision;
                    if (foundSubDivision) {
                        if ((sd.subDivisionName == foundSubDivision.subDivisionName) || (sd.subDivisionName == foundSubDivision)) {
                            if (sd && sd.counties && sd.counties.length) {
                                sd.counties.map((cr) => {
                                    if (cr.country == secFourCountries.find(ctr => ctr == cr.country)) {
                                        if (cr.products && cr.products.length) {
                                            let product = cr.products.find((pr) => pr.product);
                                            let findIndexCountry = filterSelectedCountries.indexOf(cr.country);
                                            if (findIndexCountry == -1) {
                                                filterSelectedCountries.push(cr.country)
                                            }
                                            selectedProducts.push(product);

                                        }
                                    }
                                });
                            }
                        }
                    }

                });
            }
        });*/

        if (selectedProducts.length) {
            Object.assign(sectionSeven, (sectionSeven.isHidden = false));
            EventBus.$emit("sectionCheck", sectionSeven);
            EventBus.$emit("getRefreshProducts", selectedProducts);
            EventBus.$emit("getRefreshCountries", filterSelectedCountries);

        } else {
            Object.assign(sectionSeven, (sectionSeven.isHidden = true));
            EventBus.$emit("sectionCheck", sectionSeven);
            sectionSeven.formElements.map(
                (ele) => {
                    ele.validation.required = 0;
                    ele.isInValid = false;
                    let foundEle = state.userFormSubmitArray.find(
                        (ele1) => ele1.elementId == ele.id
                    );
                    // console.log("eeeee", foundEle)
                    if (foundEle) {
                        foundEle.elements = []
                    }
                }
            );
        }
        return selectedProducts;
    }
}
export default new Helper();